import React from "react";

interface IOutsourcingBenifitsComponentProps { }

export const OutsourcingBenifitsComponent: React.FC<
    IOutsourcingBenifitsComponentProps
> = (props: IOutsourcingBenifitsComponentProps) => {
    return (
        <section id="features" className="features section">
            <div className="container">
                <div className="row gy-4">
                    <h4>Outsourcing Benefits</h4>
                    <div
                        className="features-image col-lg-6 order-lg-2"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <img
                            loading="lazy"
                            className="border-radius-10px"
                            src="/assets/img/hr-outsourcing.jpg"
                            alt="hr-outsourcing-image"
                        />
                    </div>

                    <div className="text-justify col-lg-6 order-lg-1">
                        <div
                            className="features-item d-flex ps-0 ps-lg-3 pt-4 pt-lg-0"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <i className="bi bi-clock-history flex-shrink-0"></i>
                            <div>
                                <h4>Save Time & Costs</h4>
                                <p>
                                    Streamline your operations and reduce
                                    overhead with our tailored outsourcing
                                    solutions. Leverage our expertise to
                                    optimize resources and enhance your
                                    bottom line.
                                </p>
                            </div>
                        </div>
                        {/* End Features Item*/}

                        <div
                            className="features-item d-flex mt-5 ps-0 ps-lg-3"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <i className="bi bi-calculator flex-shrink-0"></i>
                            <div>
                                <h4>Accountability & Accuracy</h4>
                                <p>
                                    Gain peace of mind with our meticulous
                                    approach, providing reliable and
                                    accurate payroll management. We
                                    prioritize data integrity and maintain
                                    strict accountability for every
                                    transaction.
                                </p>
                            </div>
                        </div>
                        {/* End Features Item*/}

                        <div
                            className="features-item d-flex mt-5 ps-0 ps-lg-3"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <i className="bi bi-hand-thumbs-up flex-shrink-0"></i>
                            <div>
                                <h4>
                                    Improve Employee Satisfaction & Enhanced
                                    Security
                                </h4>
                                <p>
                                    Empower your workforce with seamless
                                    access to HR information, boosting
                                    satisfaction and engagement. We
                                    prioritize robust data security,
                                    ensuring confidentiality and compliance
                                    with local regulations.
                                </p>
                            </div>
                        </div>
                        {/* End Features Item*/}

                        <div
                            className="features-item d-flex mt-5 ps-0 ps-lg-3"
                            data-aos="fade-up"
                            data-aos-delay="500"
                        >
                            <i className="bi bi-graph-up flex-shrink-0"></i>
                            <div>
                                <h4>
                                    Increased Productivity & Tap The Expert
                                </h4>
                                <p>
                                    Boost your team's efficiency by
                                    offloading time-consuming tasks to our
                                    expert payroll professionals. Access
                                    specialized knowledge of local
                                    regulations and best practices,
                                    maximizing productivity.
                                </p>
                            </div>
                        </div>
                        {/* End Features Item*/}
                    </div>
                </div>
            </div>
        </section>
    )
}